import {Stack, styled, useMediaQuery} from "@mui/material";
import coverSrc from "../../assets/cover.png";
import {useCachedImage} from "../../styling/useCachedImage";
import MobileMenu from "./MobileMenu";
import DesktopMenu from "./DesktopMenu";

const Header = () => {
    const isMobile = useMediaQuery('(max-width:800px)');

    const Cover = styled('img')({
        maxHeight: '300px',
        width: 'auto',
        height: 'auto',
        minWidth: 0,
        flexShrink: 1,
        padding: '20px',
        objectFit: 'contain',
        maxWidth: '100%'
    });

    const cover = useCachedImage('logo', coverSrc);

    return(
        <Stack direction="column">
            <Cover src={cover ?? coverSrc} alt="cover image"/>
            {isMobile ? <MobileMenu/> : <DesktopMenu/>}
        </Stack>
    )
}

export default Header;